function equalFaqSlideTextHeights(sliderEl) {
  const texts = sliderEl.querySelectorAll(
    ".swiper-slide .search-faq__card-item-text"
  );

  if (!texts.length) return;

  let maxHeight = 0;

  // reset first
  texts.forEach(text => {
    text.style.height = "auto";
  });

  // get tallest
  texts.forEach(text => {
    const height = text.scrollHeight;
    if (height > maxHeight) maxHeight = height;
  });

  // apply tallest height
  texts.forEach(text => {
    text.style.height = `${maxHeight}px`;
  });
}
document.addEventListener("DOMContentLoaded", function () {
  const parentDiv = document.querySelector(".search-drawer");
  if (!parentDiv) return;

  const searchInput = parentDiv.querySelector(".search-drawer__input");
  const clearBtn = parentDiv.querySelector(".search-drawer__clear");

  let productSwiper = null;
  let faqSwiper = null;
  let debounceTimer;
  let fetchController = null;
  let originalOverflow = "";
  let defaultProducts = null;
  let defaultFaq = null;
  let searchProducts = [];
  let visibleProductCount = 6; 
  let searchPages = []; 
  let visiblePageCount = 6;
  let isSearchMode = false;
   let searchProductCount = 0;
   let searchPageCount = 0;

  // ── Typewriter placeholder ──────────────────────────────────
  const fakePH    = parentDiv.querySelector("#fakePlaceholder");
  const typedSpan = fakePH?.querySelector("#typedText");

  const TW = {
    phrases:     ["What are you looking for...", "Search for products & FAQs..."],
    typeSpeed:   60,
    deleteSpeed: 35,
    pauseFull:   1800,
    pauseEmpty:  400,
    phraseIdx:   0,
    charIdx:     0,
    deleting:    false,
    running:     false,
    timer:       null,

    tick() {
      if (!this.running || !typedSpan) return;
      const phrase = this.phrases[this.phraseIdx];
      if (!this.deleting) {
        typedSpan.textContent = phrase.slice(0, ++this.charIdx);
        if (this.charIdx === phrase.length) {
          this.deleting = true;
          this.timer = setTimeout(() => this.tick(), this.pauseFull);
          return;
        }
      } else {
        typedSpan.textContent = phrase.slice(0, --this.charIdx);
        if (this.charIdx === 0) {
          this.deleting = false;
          this.phraseIdx = (this.phraseIdx + 1) % this.phrases.length;
          this.timer = setTimeout(() => this.tick(), this.pauseEmpty);
          return;
        }
      }
      this.timer = setTimeout(() => this.tick(), this.deleting ? this.deleteSpeed : this.typeSpeed);
    },

    start() {
      if (!fakePH || !typedSpan) return;
      this.running = true;
      fakePH.style.display = "";
      this.tick();
    },

    stop() {
      this.running = false;
      clearTimeout(this.timer);
      if (fakePH) fakePH.style.display = "none";
    },

    reset() {
      this.stop();
      this.charIdx  = 0;
      this.deleting = false;
      if (typedSpan) typedSpan.textContent = "";
    }
  };
  // ────────────────────────────────────────────────────────────

  function updateClearBtn() {
    if (!clearBtn || !searchInput) return;
    clearBtn.style.display = searchInput.value.length > 0 ? "block" : "none";
  }

  function showDefault() {
    const currentDefaultSection = parentDiv.querySelector(".search-product-card__item.is-slider");
    if (currentDefaultSection) currentDefaultSection.style.display = "";
    updateProductCount(false);
  }

  function destroyFaqSlider() {
    if (faqSwiper && !faqSwiper.destroyed) {
      faqSwiper.destroy(true, true);
      faqSwiper = null;
    }
  }

  function destroyProductSlider() {
    if (productSwiper && !productSwiper.destroyed) {
      productSwiper.destroy(true, true);
      productSwiper = null;
    }
  }

  function toggleSuggestResults(show) {
    const suggestWrapper = parentDiv.querySelector(".suggest-result-wrapper");
    if (suggestWrapper) suggestWrapper.style.display = show ? "" : "none";
  }

  function toggleFaq(show) {
    const faqWrapper = parentDiv.querySelector(".faq__search");
    if (faqWrapper) faqWrapper.style.display = show ? "" : "none";
  }

  function toggleProductSliderButtons(show) {
    const buttons = parentDiv.querySelector(".search-product-card__buttons-wrap");
    if (buttons) buttons.style.display = show ? "" : "none";
  }

  // ── Wrap bare children in .swiper-wrapper / .swiper-slide if needed ──
  // Swiper requires: <div class="swiper"><div class="swiper-wrapper"><div class="swiper-slide">…
  // Call this before init so existing markup is compatible.
  function ensureSwiperStructure(el) {
    if (!el) return;

    // If a .swiper-wrapper already exists we're already structured correctly
    if (el.querySelector(".swiper-wrapper")) return;

    const wrapper = document.createElement("div");
    wrapper.className = "swiper-wrapper";

    Array.from(el.children).forEach((child) => {
      if (
        child.classList.contains("swiper-button-prev") ||
        child.classList.contains("swiper-button-next") ||
        child.classList.contains("swiper-pagination")
      ) return; // leave navigation/pagination nodes in place

      child.classList.add("swiper-slide");
      wrapper.appendChild(child);
    });

    el.prepend(wrapper);
  }

  function filterFaqCards(term) {
    const currentFaq = parentDiv.querySelector(".search-faq__card-block");
    if (!currentFaq || !defaultFaq) return;

    destroyFaqSlider();

    const query = term.trim().toLowerCase();
    const filteredFaq = defaultFaq.cloneNode(true);
    const cards = filteredFaq.querySelectorAll(".search-faq__card-item");

    let matchCount = 0;

    cards.forEach((card) => {
      const searchableText = card.textContent.toLowerCase();
      if (searchableText.includes(query)) {
        matchCount++;
      } else {
        card.remove();
      }
    });

    currentFaq.replaceWith(filteredFaq);

    const faqWrapper = parentDiv.querySelector(".search-faq-wrapper");
    const faqBottom  = parentDiv.querySelector(".search-faq__bottom-header");

    if (faqWrapper) faqWrapper.style.display = matchCount ? "" : "none";
    if (faqBottom)  faqBottom.style.display  = matchCount > 1 ? "" : "none";

    requestAnimationFrame(() => {
      initFaqSlider(parentDiv);
    });
  }

  function restoreFaqCards() {
    const currentFaq = parentDiv.querySelector(".search-faq__card-block");
    if (!currentFaq || !defaultFaq) return;

    destroyFaqSlider();

    currentFaq.replaceWith(defaultFaq.cloneNode(true));

    const faqWrapper = parentDiv.querySelector(".search-faq-wrapper");
    const faqBottom  = parentDiv.querySelector(".search-faq__bottom-header");

    if (faqWrapper) faqWrapper.style.display = "";
    if (faqBottom)  faqBottom.style.display  = "";

    requestAnimationFrame(() => {
      initFaqSlider(parentDiv);
    });
  }

  function clearSearch() {
    if (!searchInput) return;

    // 1. Abort any running fetch request immediately
    if (fetchController) {
      fetchController.abort();
      fetchController = null;
    }

    // 2. Reset state variables
    isSearchMode = false;
    searchProducts = [];
    searchProductCount = 0;
    searchPageCount = 0;
    visibleProductCount = 6;
      const pagesWrapper = parentDiv.querySelector(".search-pages-wrapper");
      if (pagesWrapper) pagesWrapper.style.display = "none";
    // 3. Hide loading indicator
    hideLoading();

    toggleProductSliderButtons(true);
    searchInput.value = "";
    updateClearBtn();

    const activeItem = parentDiv.querySelector(".suggest-result__item.active");
    if (activeItem) activeItem.classList.remove("active");

    parentDiv.querySelector(".search-products-show-more")?.remove();

    if (defaultProducts) {
      const currentSlider = parentDiv.querySelector(".search-product-card__item");
      if (currentSlider) {
        currentSlider.replaceWith(defaultProducts.cloneNode(true));
        updateProductCount(false);
      }
    }

    const currentProducts = parentDiv.querySelector(".search-product-card__item");
    if (currentProducts) {
      currentProducts.classList.remove("search-product-grid");
    }

    restoreFaqCards();
    showDefault();
    toggleSuggestResults(true);
    toggleFaq(true);
    searchInput.focus();

    TW.reset();
    TW.start();

    requestAnimationFrame(() => {
      initProductSlider(parentDiv);
      initFaqSlider(parentDiv);
    });
  }

  function initProductSlider(scope = parentDiv) {
    if (isSearchMode) return;

    const el = scope.querySelector(".search-product-card__item.is-slider");
    if (!el) return;

    // Destroy stale instance
    destroyProductSlider();

    // Ensure Swiper-compatible markup
    ensureSwiperStructure(el);

    productSwiper = new Swiper(el, {
      slidesPerView:  "auto", 
      spaceBetween:   0,
      freeMode:       true,
      grabCursor:     true,
      watchOverflow:  true,     // disables swiper when all slides fit
      on: {
        slideChange: updateProductBtn,
        afterInit:   updateProductBtn,
        resize:      updateProductBtn,
      }
    });

    updateProductBtn();
  }

  function updateProductCount(showCount = true) {
    const heading     = parentDiv.querySelector(".search-product-card__heding h2");
    const productWrap = parentDiv.querySelector(".search-product-card__item");

    if (!heading) return;

    if (!showCount || !productWrap) {
      heading.textContent = "Best sellers";
      return;
    }

    if (isSearchMode) {
      const parts = [];
      
      if (searchProductCount > 0) {
        parts.push(`Products (${searchProductCount})`);
      } 

      // Fallback if no results match
      heading.textContent = parts.length > 0 ? parts.join(", ") : "No results found";
      return;
    }

    const count = productSwiper
      ? productSwiper.slides.length
      : productWrap.children.length;

    heading.textContent = `Products (${count})`;
  }

 function initFaqSlider(scope = parentDiv) {
  const el = scope.querySelector(".search-faq__card-block");
  if (!el) return;
  if (!el.querySelector(".search-faq__card-item")) return;

  destroyFaqSlider();

  ensureSwiperStructure(el);

  faqSwiper = new Swiper(el, {
    slidesPerView: "auto",
    spaceBetween: 0,
    freeMode: true,
    grabCursor: true,
    watchOverflow: true,

    on: {
      init: function () {
        requestAnimationFrame(() => {
          equalFaqSlideTextHeights(el);
          updateFaqBtn();
        });
      },

      afterInit: function () {
        requestAnimationFrame(() => {
          equalFaqSlideTextHeights(el);
          updateFaqBtn();
        });
      },

      resize: function () {
        requestAnimationFrame(() => {
          equalFaqSlideTextHeights(el);
          updateFaqBtn();
        });
      },

      slideChange: updateFaqBtn,
      progress: updateFaqBtn
    }
  });

  // fallback after Swiper finishes rendering
  setTimeout(() => {
    equalFaqSlideTextHeights(el);
    faqSwiper.update();
    updateFaqBtn();
  }, 300);
}

  function updateProductBtn() {
    if (!productSwiper) return;

    const prevBtn = parentDiv.querySelector(".search-product-card__prev-button");
    const nextBtn = parentDiv.querySelector(".search-product-card__next-button");
    if (!prevBtn || !nextBtn) return;

    const atStart = productSwiper.isBeginning;
    const atEnd   = productSwiper.isEnd;

    prevBtn.toggleAttribute("disabled", atStart);
    prevBtn.style.opacity = atStart ? 0.3 : 1;
    nextBtn.toggleAttribute("disabled", atEnd);
    nextBtn.style.opacity = atEnd ? 0.3 : 1;
  }

  function updateFaqBtn() {
    if (!faqSwiper) return;

    const progressBar  = parentDiv.querySelector(".search-faq__slide-bar");
    const prevBtn      = parentDiv.querySelector(".search-faq__bottom-slide-arrow-prev button");
    const nextBtn      = parentDiv.querySelector(".search-faq__bottom-slide-arrow-next button");

    const atStart = faqSwiper.isBeginning;
    const atEnd   = faqSwiper.isEnd;

    if (prevBtn) prevBtn.style.opacity = atStart ? 0.3 : 1;
    if (nextBtn) nextBtn.style.opacity = atEnd   ? 0.3 : 1;

    if (progressBar) {
      const totalCells   = faqSwiper.slides.length;
      const currentIndex = faqSwiper.realIndex;

      // Derive visible count from container/slide widths
      const sliderWidth  = faqSwiper.width || 1;
      const cellWidth    = faqSwiper.slides[0]?.offsetWidth || 1;
      const visibleCount = Math.max(Math.round(sliderWidth / cellWidth), 1);

      const thumbWidth     = Math.min(visibleCount / (totalCells || 1), 1);
      const scrollProgress = currentIndex / Math.max(totalCells - visibleCount, 1);

      progressBar.style.setProperty("--thumb-width", thumbWidth);
      progressBar.style.setProperty("--progress", scrollProgress);
    }
  }

  function drawerOpen() {
    originalOverflow = document.body.style.overflow;
    parentDiv.classList.add("active");
    document.body.style.overflow = "hidden";

    if (searchInput) searchInput.focus();

    if (!defaultProducts) {
      defaultProducts = parentDiv.querySelector(".search-product-card__item.is-slider")?.cloneNode(true);
    }

    if (!defaultFaq) {
      defaultFaq = parentDiv.querySelector(".search-faq__card-block")?.cloneNode(true);
    }

    updateClearBtn();
    toggleSuggestResults(true);
    toggleFaq(true);
    updateProductCount(false);

    if (!searchInput?.value) {
      TW.reset();
      TW.start();
    }

    requestAnimationFrame(() => {
      initProductSlider(parentDiv);
      initFaqSlider(parentDiv);
    });
  }

  function drawerClose() {
    parentDiv.classList.remove("active");
    document.body.style.overflow = originalOverflow;
    toggleProductSliderButtons(true);

    TW.reset();

    isSearchMode = false;
    searchProducts = [];
    visibleProductCount = 6;
    parentDiv.querySelector(".search-products-show-more")?.remove();

    if (fetchController) {
      fetchController.abort();
      fetchController = null;
    }

    destroyProductSlider();
    destroyFaqSlider();

    if (searchInput) {
      searchInput.value = "";
      updateClearBtn();
    }

    const activeItem = parentDiv.querySelector(".suggest-result__item.active");
    if (activeItem) activeItem.classList.remove("active");

    if (defaultProducts) {
      const currentProducts = parentDiv.querySelector(".search-product-card__item");
      if (currentProducts) {
        const freshDefault = defaultProducts.cloneNode(true);
        freshDefault.classList.remove("search-product-grid");
        currentProducts.replaceWith(freshDefault);
      }
    }

    restoreFaqCards();
    toggleSuggestResults(true);
    toggleFaq(true);
    updateProductCount(false);

    document.dispatchEvent(new CustomEvent("predictive-search:close-all"));
  }

  function showLoading() {
    const loader = parentDiv.querySelector(".search-loading");
    if (loader) loader.style.display = "flex";
  }

  function hideLoading() {
    const loader = parentDiv.querySelector(".search-loading");
    if (loader) loader.style.display = "none";
  }

  function isDrawerOpen() {
    return parentDiv.classList.contains("active");
  }

  function renderSearchGrid() {
  const productWrap = parentDiv.querySelector(".search-product-card__item");
  const pagesWrapper = parentDiv.querySelector(".search-pages-wrapper");
  const pagesContainer = parentDiv.querySelector(".search-pages-card__item");
  const pagesTitle = parentDiv.querySelector(".search-pages-title");

  if (!productWrap) return;

  toggleProductSliderButtons(false);
  productWrap.classList.add("search-product-grid");
  productWrap.classList.remove("swiper", "swiper-initialized", "swiper-horizontal");
  productWrap.removeAttribute("tabindex");
  productWrap.innerHTML = "";

  // 1. Render Products (only up to visible count)
  searchProducts.slice(0, visibleProductCount).forEach((card) => {
    productWrap.appendChild(card.cloneNode(true));
  });

  // 2. Load More Button (positioned right after Products)
  let showMoreBtn = parentDiv.querySelector(".search-products-show-more");
  if (!showMoreBtn) {
    showMoreBtn = document.createElement("button");
    showMoreBtn.type = "button";
    showMoreBtn.className = "search-products-show-more";
    showMoreBtn.textContent = "Show more";
    productWrap.after(showMoreBtn);
  }

  showMoreBtn.style.display =
    visibleProductCount < searchProducts.length ? "block" : "none";

  // 3. Render Pages Below (or hide if empty)
  if (pagesWrapper && pagesContainer) {
    pagesContainer.innerHTML = "";

    if (searchPages.length > 0) {
      if (pagesTitle) pagesTitle.textContent = `Pages (${searchPages.length})`;
      
      searchPages.forEach((card) => {
        pagesContainer.appendChild(card.cloneNode(true));
      });
      
      pagesWrapper.style.display = "block";
    } else {
      pagesWrapper.style.display = "none";
    }
  }

  updateProductCount(true);
}
  // ── Build a product card DOM element from a JSON product object ──
  function buildProductCard(product) {
    const card = document.createElement("div");
    card.className = "search-product-card__slide";

    const price = product.price_min
      ? Number(product.price_min).toLocaleString("en-US", { style: "currency", currency: window.Shopify?.currency?.active || "USD" })
      : "";

    const comparePrice = product.compare_at_price_min && product.compare_at_price_min > product.price_min
      ? Number(product.compare_at_price_min).toLocaleString("en-US", { style: "currency", currency: window.Shopify?.currency?.active || "USD" })
      : "";

    const imgSrc  = product.featured_image?.url || product.images?.[0] || "";
    const imgHtml = imgSrc
      ? `<img src="${imgSrc}" alt="${product.title}" loading="lazy" width="300" height="300">`
      : `<div class="search-product-card__no-image"></div>`;

    const variantId = product.variants?.[0]?.id || "";

    const badgeHtml = comparePrice
      ? `<span class="search-product-card__badge">Sale</span>`
      : "";

    card.innerHTML = `
      <div class="search-product-card__inner">
        ${badgeHtml}
        <a href="${product.url}" class="search-product-card__image-link">
          ${imgHtml}
        </a>
        <div class="search-product-card__info">
          <a href="${product.url}" class="search-product-card__title">${product.title}</a>
          <div class="search-product-card__price">
            <span class="search-product-card__price--current">${price}</span>
          </div>
         
        </div>
      </div>
    `;

    return card;
  }

  
   function buildPageCard(page) {
    const card = document.createElement("div");
    card.className = "search-product-card__slide search-page-card__slide";

    card.innerHTML = `
      <div class="search-product-card__inner search-page-card__inner">
        <a href="${page.url}" class="search-page-card__media">
        <span class="search-product-card__badge page-badge">Page</span>
        </a>
        <div class="search-product-card__info">
          <a href="${page.url}" class="search-product-card__title">${page.title}</a>
        </div>
      </div>
    `;

    return card;
  }

 // Add these variables alongside your other let declarations at top of scope:
  // let searchProductCount = 0;
  // let searchPageCount = 0;

  function fetchProducts(term) {
    if (!term) return;

    toggleSuggestResults(false);
    toggleFaq(false);

    if (fetchController) fetchController.abort();
    fetchController = new AbortController();

    showLoading();

    const shopRoot = window.Shopify?.routes?.root || "/";

    const params = new URLSearchParams({
      q: term,
      "resources[type]":        "product,page",
      "resources[limit]":       24,
      "resources[limit_scope]": "each"
    });

    fetch(`${shopRoot}search/suggest.json?${params}`, {
      signal: fetchController.signal,
      headers: { "Content-Type": "application/json" }
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
       .then((data) => {
        if (!isSearchMode && searchInput?.value.trim() === "") {
          hideLoading();
          return;
        }
        const products = data?.resources?.results?.products || [];
        const rawPages = data?.resources?.results?.pages || [];

        // Exclude pages whose title includes "sitemap" (case-insensitive)
        const pages = rawPages.filter(page => 
          !page.title?.toLowerCase().includes("sitemap")
        );

        // Track filtered counts for the heading
        searchProductCount = products.length;
        searchPageCount = pages.length;

        const currentSlider = parentDiv.querySelector(".search-product-card__item");
        if (currentSlider) {
          destroyProductSlider();

          const productCards = products.map(buildProductCard);
          const pageCards = pages.map(buildPageCard);

          searchProducts = productCards;
          searchPages = pageCards;
          visibleProductCount = 6; 
          isSearchMode        = true;

          renderSearchGrid();
        }

        filterFaqCards(term);

        requestAnimationFrame(() => {
          updateProductCount(true);
          hideLoading();
        });
      })
      .catch((err) => {
        hideLoading();
        if (err.name !== "AbortError") console.error(err);
      });
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest(".icon-search_drawer")) {
      drawerOpen();
      return;
    }

    const showMoreBtn = e.target.closest(".search-products-show-more");

    if (showMoreBtn) {
      if (showMoreBtn.classList.contains("is-loading")) return;

      showMoreBtn.classList.add("is-loading");
      showMoreBtn.disabled = true;
      showMoreBtn.innerHTML = `<span class="show-more-spinner"></span> Loading`;

      setTimeout(() => {
        visibleProductCount += 6;
        renderSearchGrid();

        const updatedBtn = parentDiv.querySelector(".search-products-show-more");
        if (updatedBtn) {
          updatedBtn.classList.remove("is-loading");
          updatedBtn.disabled = false;
          updatedBtn.textContent = "Show more";
        }
      }, 800);

      return;
    }

    if (!isDrawerOpen()) return;

    if (e.target.closest(".search-drawer__clear")) {
      clearSearch();
      return;
    }

    if (e.target.closest(".search-product-card__prev-button")) {
      productSwiper?.slidePrev();
      return;
    }

    if (e.target.closest(".search-product-card__next-button")) {
      productSwiper?.slideNext();
      return;
    }

    if (e.target.closest(".search-faq__bottom-slide-arrow-prev")) {
      faqSwiper?.slidePrev();
      return;
    }

    if (e.target.closest(".search-faq__bottom-slide-arrow-next")) {
      faqSwiper?.slideNext();
      return;
    }

    const suggestItem = e.target.closest(".suggest-result__item");
    if (suggestItem) {
      const activeItem = parentDiv.querySelector(".suggest-result__item.active");
      if (activeItem) activeItem.classList.remove("active");

      suggestItem.classList.add("active");

      const searchTerm = suggestItem.dataset.search;

      if (searchInput && searchTerm) {
        searchInput.value = searchTerm;
        searchInput.focus();
        updateClearBtn();
        TW.stop();
      }

      fetchProducts(searchTerm);
      return;
    }

    if (e.target.closest(".search-drawer__submit")) {
      e.preventDefault();

      const term = searchInput?.value.trim();
      if (!term) return;

      const shopRoot = window.Shopify?.routes?.root || "/";
      window.location.href = `${shopRoot}search?q=${encodeURIComponent(term)}&options[prefix]=last&type=product,page`;
      return;
    }

    if (e.target.closest(".search_drawer_back_icon")) {
      drawerClose();
      return;
    }

    if (e.target.closest(".search-drawer__cancel")) {
      clearSearch();
      return;
    }

    if (e.target.closest("form[action='/cart/add']")) {
      setTimeout(() => {
        drawerClose();
      }, 500);
    }

    if (!e.target.closest(".search-drawer")) {
      drawerClose();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isDrawerOpen()) {
      drawerClose();
    }
  });

 searchInput?.addEventListener("input", function () {
    const value = this.value.trim();

    updateClearBtn();

    if (this.value.length > 0) {
      TW.stop();
    } else {
      TW.reset();
      TW.start();
    }

    clearTimeout(debounceTimer);

    if (!value.length) {
      // Abort active fetch if user erased text quickly
      if (fetchController) {
        fetchController.abort();
        fetchController = null;
      }

      hideLoading();

      isSearchMode = false;
      searchProducts = [];
      searchProductCount = 0;
      searchPageCount = 0;
      visibleProductCount = 6;
      
      parentDiv.querySelector(".search-products-show-more")?.remove();
      toggleProductSliderButtons(true);

      if (defaultProducts) {
        const currentSlider = parentDiv.querySelector(".search-product-card__item");
        if (currentSlider) {
          currentSlider.replaceWith(defaultProducts.cloneNode(true));
        }
      }

      showDefault();
      restoreFaqCards();
      toggleSuggestResults(true);
      toggleFaq(true);

      requestAnimationFrame(() => {
        initProductSlider(parentDiv);
        initFaqSlider(parentDiv);
        updateProductCount(false);
      });

      return;
    }

    debounceTimer = setTimeout(() => {
      fetchProducts(value);
    }, 300);
  });

  document.addEventListener("theme:section:reinit", () => {
    if (isDrawerOpen()) {
      initProductSlider(parentDiv);
      initFaqSlider(parentDiv);
    }
  });

  document.addEventListener("predictive-search:close-all", () => {
    if (isDrawerOpen()) {
      initProductSlider(parentDiv);
      initFaqSlider(parentDiv);
    }
  });
});

// ── Cart add handler (Dawn-native fetch approach) ────────────
document.addEventListener("submit", async function (event) {
  const form = event.target;

  if (!form.matches('.search-product-card__item form[action="/cart/add"]')) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const button = form.querySelector('[type="submit"], [name="add"]');
  const originalButtonHTML = button ? button.innerHTML : "";

  if (button) {
    button.disabled = true;
    button.classList.add("is-loading");
    button.innerHTML = `<span class="cart-add-spinner"></span>`;
  }

  try {
    const formData = new FormData(form);

    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" }
    });

    if (!response.ok) throw await response.json();

    const product = await response.json();

    document.dispatchEvent(new CustomEvent("cart:open"));
    document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product } }));

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      fetch(`${window.Shopify?.routes?.root || "/"}?section_id=cart-drawer`)
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          cartDrawer.renderContents({ getSections: () => ({ "cart-drawer": doc.querySelector("#shopify-section-cart-drawer")?.innerHTML || "" }) });
        })
        .catch(console.error);
    }

  } catch (error) {
    console.error("Quick add failed:", error);
  } finally {
    if (button) {
      button.disabled = false;
      button.classList.remove("is-loading");
      button.innerHTML = originalButtonHTML;
    }
  }
}, true);